import { Fragment } from 'react';
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  RadioGroup,
  useTheme,
} from '@mui/material';
import SectionTitle from '../../components/SectionTitle';
import { IFormValues, IFormWatch } from 'routes/Main/type';
import useTableForm from '../../hooks/useTableForm';
import MuiRadioGroupSub from './components/MuiRadioGroupSub';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const NDIContents = (props: Props) => {
  const { palette } = useTheme();

  const { sumValues } = useTableForm(props);
  const { disabled, setValue, getValues } = props;

  const answers = [
    {
      id: 'ndi01',
      title: 'Phần 1 - Mức độ đau',
      desc: [
        'Hiện tại không có cơn đau nào',
        'Hiện tại  đau nhẹ',
        'Hiện tại tương đối đau',
        'Hiện tại đau khá nhiều',
        'Hiện tại đau rất  nhiều',
        'Hiện tại quá đau, không thể chịu đựng nổi',
      ],
    },
    {
      id: 'ndi02',
      title: 'Phần 2 - Chăm sóc bản nhân ( Giặt giũ, Mặc quần áo, khác.)',
      desc: [
        'Tôi có thể tự chăm sóc bản thân bình thường mà không gây thêm đau đớn nào',
        'Tôi có thể tự chăm sóc bản thân bình thường, nhưng nó gây thêm đau đớn',
        'Đau khi tôi tự chăm sóc bản thân nhưng cần nhiều thời gian cũng như sự cẩn thận',
        'Tôi cần giúp đỡ một phần nhưng vẫn tự làm được hầu hết các hoạt động chăm sóc bản nhân',
        'Tôi cần giúp đỡ mỗi ngày trong hầu hết các hoạt động chăm sóc bản thân',
        'Tôi không thể tự mặc quần áo, tắm rửa khó khăn và phải nằm trên giường',
      ],
    },
    {
      id: 'ndi03',
      title: 'Phần 3 - Nâng vật nặng',
      desc: [
        'Tôi có thể nâng vật nặng mà không gây đau thêm',
        'Tôi có thể nâng vật nặng, nhưng gây đau thêm',
        'Vì đau nên tôi không thể nâng vật nặng lên từ sàn nhà, nhưng tôi có thể nâng được nếu chúng được đặt ở vị trí thuận tiện như trên bàn',
        'Vì đau nên tôi không thể nâng vật nặng, chỉ có thể nâng vật có khối lượng từ nhẹ đến trung bình nếu vật ở vị trí thuận lợi',
        'Tôi chỉ có thể nâng vật có khối lượng rất nhẹ',
        'Tôi không thể nâng được bất cứ vật gì',
      ],
    },
    {
      id: 'ndi04',
      title: 'Phần 4 - Đọc',
      desc: [
        'Tôi có thể đọc bao nhiêu tùy thích mà không bị đau cổ',
        'Tôi có thể đọc bao nhiêu tùy thích với một cơn đau nhẹ ở cổ',
        'Tôi có thể đọc bao nhiêu tùy thích với cơn đau cổ vừa phải',
        'Tôi không thể đọc nhiều như tôi muốn vì đau vừa ở cổ',
        'Tôi hầu như không thể đọc được gì vì bị đau cổ quá nặng',
        'Tôi không thể đọc được chút nào',
      ],
    },
    {
      id: 'ndi05',
      title: 'Phần 5 - Đau đầu',
      desc: [
        'Tôi không đau đầu chút nào',
        'Tôi bị đau đầu nhẹ, thỉnh thoảng',
        'Tôi bị đau đầu vừa phải và không thường xuyên xảy ra',
        'Tôi bị đau đầu vừa phải, thường xuyên',
        'Tôi bị đau đầu nặng, thường xuyên xảy ra',
        'Tôi hầu như lúc nào cũng bị đau đầu',
      ],
    },
    {
      id: 'ndi06',
      title: 'Phần 6 - Tập trung',
      desc: [
        'Tôi có thể tập trung hoàn toàn khi tôi muốn mà không gặp khó khăn gì',
        'Tôi có thể tập trung hoàn toàn khi tôi muốn với một chút khó khăn',
        'Tôi khá khó tập trung khi tôi muốn',
        'Tôi gặp nhiều khó khăn trong việc tập trung khi tôi muốn',
        'Tôi gặp rất nhiều khó khăn trong việc tập trung khi tôi muốn',
        'Tôi không thể tập trung chút nào',
      ],
    },
    {
      id: 'ndi07',
      title: 'Phần 7 - Làm việc',
      desc: [
        'Tôi có thể làm bất kể số lượng việc tôi muốn',
        'Tôi chỉ có thể làm công việc thường ngày của mình, nhưng không thể làm hơn nữa',
        'Tôi có thể làm hầu hết các công việc thường ngày, nhưng không thể làm hơn nữa',
        'Tôi không thể làm công việc thường ngày của mình',
        'Tôi hầu như không thể làm bất kỳ công việc nào',
        'Tôi không thể làm bất cứ việc gì',
      ],
    },
    {
      id: 'ndi08',
      title: 'Phần 8 - Lái xe',
      desc: [
        'Tôi có thể lái xe mà không bị đau cổ',
        'Tôi có thể lái xe bao lâu tùy thích với một cơn đau nhẹ ở cổ',
        'Tôi có thể lái xe bao lâu tùy thích với một cơn đau vừa phải ở cổ',
        'Tôi không thể lái xe lâu như tôi muốn vì bị đau cổ vừa phải',
        'Tôi hầu như không thể lái xe vì bị đau cổ quá nặng',
        'Tôi hoàn toàn không thể lái xe được vì cổ',
      ],
    },
    {
      id: 'ndi09',
      title: 'Phần 9 - Ngủ',
      desc: [
        'Không bị mất ngủ do đau gây nên',
        'Tôi bị rối loạn giấc ngủ rất nhẹ (mất ngủ khoảng 1 giờ)',
        'Tôi bị rối loạn giấc ngủ nhẹ (mất ngủ 1-2 giờ)',
        'Tôi bị rối loạn giấc ngủ vừa (2-3 giờ mất ngủ)',
        'Tôi bị rối loạn giấc ngủ nhiều (3-5 tiếng mất ngủ)',
        'Giấc ngủ của tôi bị rối loạn hoàn toàn (5-7 tiếng mất ngủ)',
      ],
    },
    {
      id: 'ndi10',
      title: 'Phần 10 - Giải trí',
      desc: [
        'Tôi có thể tham gia tất cả các hoạt động giải trí mà không bị đau cổ chút nào',
        'Tôi có thể tham gia tất cả các hoạt động giải trí của mình, với đau cổ nhẹ',
        'Tôi có thể tham gia hầu hết, nhưng không phải tất cả các hoạt động giải trí thông thường của mình vì bị đau cổ',
        'Tôi có thể tham gia một số hoạt động giải trí thông thường vì bị đau cổ',
        'Tôi hầu như không thể tham gia hoạt động giải trí nào vì đau cổ',
        'Tôi không thể tham gia bất kỳ hoạt động giải trí nào cả',
      ],
    },
  ];

  const watchSumValues = () => {
    const values = answers.map(({ id }) => {
      if (props.watch(`${id}`) === undefined) {
        return 0;
      } else {
        return Number(props.watch(`${id}`));
      }
    });
    return sumValues(values);
  };

  // console.log('기본값', Number(getValues('ndi10')));

  return (
    <Fragment>
      <Typography sx={{ fontSize: '14px', margin: '40px 0 -10px 25px' }}>
        Bảng câu hỏi này được thiết kế để cung cấp cho chúng tôi thông tin về
        việc cơn đau cổ của bạn đã ảnh hưởng như thế nào đến khả năng quản lý
        của bạn trong cuộc sống hàng ngày. Vui
        <br />
        lòng trả lời bằng cách chọn một câu trả lời phù hợp nhất với bạn cho mỗi
        câu hỏi.Chúng tôi nhận thấy rằng bạn có thể cho rằng hai hoặc nhiều
        tuyên bố trong bất kỳ phần nào có liên quan
        <br />
        đến bạn nhưng vui lòng chỉ đánh dấu vào ô mô tả chính xác nhất vấn đề
        của bạn.
      </Typography>
      {answers.map(
        (answer: { id: string; title: string; desc: string[] }, idx) => (
          <>
            <SectionTitle title={answer.title} />
            <Grid item xs={12}>
              <RadioGroup
                name={answer.title}
                defaultValue={Number(getValues(`answer.id`))}
              >
                <Table aria-label="simple table">
                  <TableBody>
                    {answer.desc.map((v, i) => {
                      return (
                        <TableRow>
                          <TableCell
                            sx={{
                              width: '80%',
                            }}
                          >
                            {v}
                          </TableCell>
                          <TableCell sx={{ width: '10%' }}>{`${i}`}</TableCell>
                          <TableCell>
                            <MuiRadioGroupSub
                              disabled={disabled}
                              name={`${answer.title}`}
                              values={[i]}
                              value={Number(getValues(`${answer.id}`))}
                              defaultValue={Number(getValues(`${answer.id}`))}
                              onChange={() => {
                                setValue(`${answer.id}`, i);
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </RadioGroup>
            </Grid>
          </>
        )
      )}

      <Grid item xs={12}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            Tổng : {watchSumValues()} / 50
          </Typography>
          <Typography
            minWidth={115}
            variant="caption"
            sx={{ color: `${palette.primary.dark}`, marginTop: '30px' }}
          >
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                0-4
              </Box>
              Không khuyết tật
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                5-14
              </Box>
              Khuyết tật nhẹ
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                15-24
              </Box>
              Khuyết tật vừa phải
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                25-34
              </Box>
              Khuyết tật nặng
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                35-50
              </Box>
              Hoàn toàn
            </Typography>
          </Typography>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default NDIContents;
